import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MasterInformationService {
  constructor(private http: HttpClient) {}

  // ---------------------- Create City API ---------------------- //

  postCityApi(api: string, params: any) {
    const url = `${environment.baseUrl}${api}?cityName=${params.cityName}`;
    const formData = new FormData();
    formData.append('coordinateString', params.coordinateString);
    return this.http.post(url, formData);
  }

  // ---------------------- Edit Coordinates API ---------------------- //

  editCoordinates(api: string, params: any) {
    const url = `${environment.baseUrl}${api}?cityId=${params.cityId}`;
    const formData = new FormData();
    formData.append('coordinateString', params.coordinateString);
    return this.http.post(url, formData);
  }

  // ---------------------- Get City List API ---------------------- //

  getCityList(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  
  getCityBasedList(api: string,cityID:any) {
    return this.http.get(environment.baseUrl + api +'?cityId='+cityID);
  }

  deleteCity(api:string,city:any){
    // /api/BackOffice/DeleteCity?cityId=84&cityName=1
   const url = `${environment.baseUrl}${api}?cityId=${city.id}&cityName=1`;
    return this.http.post(url, '');
  }

  // ---------------------- Active & Inactive City API ---------------------- //

  postActiveInactiveCity(api: string, cityId: any, status: boolean) {
    const url = `${environment.baseUrl}${api}?cityId=${cityId}&status=${status}`;
    return this.http.post(url, '');
  }

  // ---------------------- Create Zone API ---------------------- //

  postZoneApi(params: any, api: string): Observable<any> {
    const url = `${environment.baseUrl}${api}?Zone=${params.Zone}&cityId=${params.cityId}`;
    return this.http.post(url, null);
  }

  // ---------------------- Get Zone List by Id API ---------------------- //

  getZoneList(api: string): Observable<any> {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  // getZoneList(cityId: any, api: string) {
  //   const url = `${environment.baseUrl}${api}?cityId=${cityId}`
  //   return this.http.get(url)
  // }

  // ---------------------- Active & Inactive Zone API ---------------------- //

  postActiveInactiveZone(
    api: string,
    cityId: any,
    ZoneId: any,
    status: boolean
  ) {
    const url = `${environment.baseUrl}${api}?cityId=${cityId}&ZoneId=${ZoneId}&status=${status}`;
    return this.http.post(url, '');
  }

  // ---------------------- Add Container API ---------------------- //

  postContainerApi(params: any, api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get All List Container API ---------------------- //

  getAllContainer(api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  getSAAllContainer(api: string, cityId: any = null) {
    let params: string = '';

    if (cityId) {
      params += `?cityId=${cityId}`;
    }

    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Get Container Name API ---------------------- //

  getContainerName(api: string): Observable<any> {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  getFilteredContainer(api: string, cityId: any = null): Observable<any> {
    let params: string = '';

    if (cityId) {
      params += `?cityId=${cityId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Get Container Capacity List API ---------------------- //

  getContainerCapacity(api: string, containerName: any) {
    const url = `${environment.baseUrl}${api}?containerName=${containerName}`;
    return this.http.get(url);
  }

  // ---------------------- Add Container Price API ---------------------- //

  postContainerPrice(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Container Price List API ---------------------- //

  getContainerPriceList(api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  getFilteredPriceList(api: string, cityId: any = null) {
    let params: string = '';

    if (cityId) {
      params += `?cityId=${cityId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Update Container Price List API ---------------------- //

  updateContainerPriceList(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Sms List API ---------------------- //

  GetSmsLogDetails(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Version Status API ---------------------- //

  getVersionStatus(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Notification API ---------------------- //

  getNotification(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- User Account Delete API ---------------------- //

  accountDelete(api: string, params: any) {
    const url = `${environment.baseUrl}${api}?phoneNo=${params.phoneNumber}&status=${params.status}`;
    return this.http.post(url, params);
  }

  // ---------------------- Add Commission API ---------------------- //

  postAddCommission(api: string, params: any) {
    const url = `${environment.baseUrl}${api}?cityId=${params.cityId}&containerRentalPercentage=${params.containerRentalPercentage}&tripsPercentage=${params.tripsPercentage}&disposalPercentage=${params.disposalPercentage}`;
    return this.http.post(url, '');
  }

  // ---------------------- Get Commission List API ---------------------- //

  getCommissionList(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Update Commission API ---------------------- //

  updateCommission(api: string, params: any) {
    const url = `${environment.baseUrl}${api}?cityId=${params.cityId}&containerRentalPercentage=${params.containerRentalPercentage}&tripsPercentage=${params.tripsPercentage}&disposalPercentage=${params.disposalPercentage}`;
    return this.http.post(url, '');
  }

  // ---------------------- Get Filtered Commission API ---------------------- //

  filteredCommissionList(api: string, cityId: any) {
    let params: string = '';

    if (cityId) {
      params += `?cityId=${cityId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Post City Configuration API ---------------------- //

  cityConfig(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Post City Configuration API ---------------------- //

  cityConfigList(api: string, cityId: any) {
    let params: string = '';

    if (cityId) {
      params += `?cityId=${cityId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Post Add Sidemenu API ---------------------- //

  addSidemenu(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Sidemenu API ---------------------- //

  getMainmenu(api: string, mainMenuId?: any) {
    return this.http.get(environment.baseUrl + api, mainMenuId);
  }

  // ---------------------- Get Sidemenu API ---------------------- //

  getSubmenu(api: string, subMenuId?: any) {
    return this.http.get(environment.baseUrl + api, subMenuId);
  }

  // ---------------------- Delete MainMenu API ---------------------- //

  deleteMainMenu(api: string, mainMenuId: any): Observable<any> {
    const url = `${environment.baseUrl}${api}?MainMenuId=${mainMenuId}`;
    return this.http.post(url, '');
  }

  // ---------------------- Update MainMenu API ---------------------- //

  updateMainMenu(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Add SubMenu API ---------------------- //

  addSubMenu(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Delete SubMenu API ---------------------- //

  deleteSubMenu(api: string, subMenuId: any): Observable<any> {
    const url = `${environment.baseUrl}${api}?SubMenuId=${subMenuId}`;
    return this.http.post(url, '');
  }

  // ---------------------- Add Menu Config API ---------------------- //

  addMenuConfig(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Add Menu Mapping for Users ---------------------- //

  addMenuMapping(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Menu Mapping API ---------------------- //

  getMenuMappingList(api: string, userType?: any) {
    return this.http.post(environment.baseUrl + api, '');
  }

  private apiUrl = 'http://192.168.2.141:12008/api/Account/UserRegistration';

  registerCustomer(
    formData: any,
    crFile: any,
    vatFile: any,
    bankFile: any
  ): Observable<any> {
    const uploadData = new FormData();
    // Append text fields
    uploadData.append('UserName', formData.customerName);
    uploadData.append('Address', formData.address);
    uploadData.append('PhNo', formData.phoneNumber);
    uploadData.append('EmailAddress', formData.emailAddress);
    uploadData.append('Bankname', formData.bankName);
    uploadData.append('IBANNumber', formData.ibanNumber);
    uploadData.append('CRNumber', formData.crNumber);
    uploadData.append('VATNumber', formData.vatNumber);

    // Append file uploads
    if (crFile) {
      uploadData.append('crFile', crFile);
    }
    if (vatFile) {
      uploadData.append('vatFile', vatFile);
    }
    if (bankFile) {
      uploadData.append('BankFile', bankFile);
    }

    return this.http.post(this.apiUrl, uploadData);
  }

  // ---------------------- Post Push Notification API ---------------------- //

  postPushNotification(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Push Notification API ---------------------- //

  getPushNotification(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Delete Push Notification API ---------------------- //

  deleteNotification(api: string, notificationId: any) {
    const url = `${environment.baseUrl}${api}?PushNotificationId=${notificationId}`;
    return this.http.post(url, '');
  }
}
